//var apibaseurl = "http://localhost:52542/api/"
//var apibaseurl = "http://localhost:63606/api/" //lambda Local
//var apibaseurl = "http://13.233.231.218:8080/api/"
//var apibaseurl = "https://api.sgbregistration.in/api/"
//var apibaseurl = "https://d2v8797bj7.execute-api.ap-south-1.amazonaws.com/Prod/api/" //lambda Prod
var apibaseurl = "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/" //lambda Prod
//var apibaseurl = "https://v24g13l91k.execute-api.ap-south-1.amazonaws.com/Prod/api/" //lambda UAT

//var apibaseurl = "https://localhost:44344/api/" //lambda Prod
import Vue from 'vue'
import VueResource from 'vue-resource';
import store from '../store'

//const header = {Authorization: store.getters.authToken};

export default {
    login(user) {
        return Vue.http.post(apibaseurl + 'Login/ValidateUser', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    signup(user) {
        return Vue.http.post(apibaseurl + 'Signup/SignupUser', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    frgot(user) {
        return Vue.http.post(apibaseurl + 'Signup/ForgotPassword', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    //Dashboad APIs
    getEvents(userid) {
        return Vue.http.get(apibaseurl + 'Events/ReadActiveEventsUser/'+ userid ,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getEventbyId(id) {
        return Vue.http.get(apibaseurl + 'Events/ReadEventByID/' , id ,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getMeritEvents() {
        return Vue.http.get(apibaseurl + 'Events/ReadMeritEvents',{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getUserCategory(userid, boardid) {
        return Vue.http.get(apibaseurl + 'Registration/getUserCategory/' + userid + '/' + boardid,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    applyForJob(eventid, userid) {
        return Vue.http.get(apibaseurl + 'Events/GenerateUserApplicatioNo/' + eventid + '/' + userid,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Get Masters for the Registration
    getReligion() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllReligionType',{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getCategory() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllCategoryType',{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getStates() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllState',{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getDistricts(stateid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadDistrictByStateID/' + stateid,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getTaluka(districtid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadTalukaByDistID/' + districtid,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getBoards(institute, stateid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadBoardByStateID/' + institute + "/" + stateid,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getQualifications() {
        return Vue.http.get(apibaseurl + 'Masters/ReadQualificationType',{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getDegreeTypes(qualifn) {
        return Vue.http.get(apibaseurl + 'Masters/ReadDegreeByQualificationTypeID/' + qualifn,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Registration
    saveQualification(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserQualifications', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserQualification(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserQualification/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Nomination
    saveNomination(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserNomination', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteNominee(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserNomineeDetailsRm', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Nominations
    ReadUserNominations(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserNomineeByUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Physical Details
    savePhysicalDetails(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserPhysicalDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Physical Details
    ReadUserPhysicalDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserPhysicalDetails/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }  
        });
    },

    //Save Declaration
    saveUserDeclaration(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserDeclaration', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Declaration
    ReadUserDecleration(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserDecleration/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //save Personal Details
    saveUserRegistration(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserRegistration', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Personal Details ReadUserDetailByUserID
    ReadUserDetail(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
        //return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserQualification/'+ user);
    },

    ReadUserDetail2(user) {
        //return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/'+ user);
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserQualification/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    //Save Address
    saveUserAddress(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserAddress', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUseCorrespondanceAddress(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUseCorrespondanceAddressByUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    ReadUserPermanentAddress(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserPermanentAddressByUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserEmgContactDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserEmgContactDetailsByUserID/' + user);
    },

    //save experience
    saveUserExperience(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserExperience', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },

    ReadUserExperience(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserExprienceDetails/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //summary tab
    ReadUsePrfileStatus(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUsePrfileStatus/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Family member details
    saveFamilyMember(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserFamilyMember', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteFamilyMember(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserFamilyMemberRm', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Familymembers
    ReadFamilyMembers(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserFamilyDetailbyUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    ReadRelations() {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserRelationship',{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDocumentPath(user) {
        //UserDocumentDetails
        return Vue.http.post(apibaseurl + 'Registration/UserPoliceVerDocument', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDocumentPathVeri(user) {
        //UserDocumentDetails
        return Vue.http.post(apibaseurl + 'Registration/UserVeriDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readDocumentPath(user) {

        return Vue.http.get(apibaseurl + 'Registration/ReadUserDocuments/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readVeriDocumentPath(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserVeriDocuments/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDocumentStatus(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readSGBoardName() {
        return Vue.http.get(apibaseurl + 'Masters/ReadSecurityBoard/',{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    readBoardMapping(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserBoardChoice/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    saveBoardMapping(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserBoardChoices', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getEventIdByEventType(eventType, id) {
        return Vue.http.get(apibaseurl + 'Events/ReadEventIdByEventType/' + eventType + "/" + id,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getPmtRequest(pmtdtls) {
        return Vue.http.post(apibaseurl + 'PmtGateway/PmtRequest', pmtdtls, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Request to start the instamojo transaction will be sent to server.
    //Server will generate the url to be contacted. This url will be used for connecting to InstaMojo.
    getPmtRequestInstaM(pmtdtls) {
        return Vue.http.post(apibaseurl + 'PmtGateway/PmtRequestInstaM', pmtdtls, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    //Read the payment details stored in the database by InstaMojo server.
    //Based on the details a receipt will be displayed
    ReadPaymentStatusInsta(user) {
        return Vue.http.post(apibaseurl + 'PmtGateway/GetPaymentDetailsInstaM', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    getUserPaymentDetails(user) {
        return Vue.http.get(apibaseurl + 'PmtGateway/GetUserPaymentDetails/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    getFees(user) {
        return Vue.http.post(apibaseurl + 'Masters/ReadFeesByCateBoard', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getAgencyRegistrationDetails(userid, regtype) {
        return Vue.http.get(apibaseurl + 'PmtGateway/GetUserPaymentDetails/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    SaveRegistrationDetails(regDetails) {
        return Vue.http.post(apibaseurl + 'AgencyRegistration/SaveAgencyRegistration', regDetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },
    // SavePERegistration(regDetails) {
    //     return Vue.http.post(apibaseurl + 'AgencyRegistration/SavePERegistration', regDetails, {
    //         headers: {
    //             "Content-Type": "application/json",

    //         }
    //     })
    // },
    // ReadPERegistrationDetails(userid, regtype) {
    //     return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadPERegistrationDetails/' + userid + "/" + regtype);
    // },
    ReadRegistrationDetails(userid, regtype) {
        return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadAgencyRegistrationDetails/' + userid + "/" + regtype,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    ReadRegistrationDetailsOnbehalf(userid, regtype) {
        return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadRegistrationByID/' + userid + "/" + regtype,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    getUserApplications(userid) {
        return Vue.http.get(apibaseurl + 'Events/GetUserApplications/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    getAgencyEmployerMapping(agencyId) {
        return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadAgencyEmployerMapping/' + agencyId,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    updateAgencyEmployerMapping(form) {
        return Vue.http.post(apibaseurl + 'AgencyRegistration/UpdateAgencyEmployerMapping', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },

    getAgencyGuardMapping(agencyId) {
        return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadAgencyGuardMapping/' + agencyId,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    updateAgencyGuardMapping(form) {
        return Vue.http.post(apibaseurl + 'AgencyRegistration/UpdateAgencyGuardMapping', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },


    searchEmployer(srchWord, srchType) {
        if (srchType == 1) {
            return Vue.http.get(apibaseurl + 'AgencyRegistration/SearchEmployerByRegistrationNumber/' + srchWord,{
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + store.getters.authToken
    
                }
            });
        }
        else {
            return Vue.http.get(apibaseurl + 'AgencyRegistration/SearchEmployerByName/' + srchWord,{
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + store.getters.authToken
    
                }
            });
        }
    },

    searchGuard(srchWord, srchType) {
        if (srchType == 1) {
            return Vue.http.get(apibaseurl + 'AgencyRegistration/SearchGuardByRegistrationNumber/' + srchWord,{
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + store.getters.authToken
    
                }
            });
        }
        else {
            return Vue.http.get(apibaseurl + 'AgencyRegistration/SearchGuardByName/' + srchWord,{
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + store.getters.authToken
    
                }
            });
        }
    },

    getDashbord(boardid) {
        return Vue.http.get(apibaseurl + 'db/getdashboardsummary/' + boardid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    ReadBFormList(UserID) {
        return Vue.http.get(apibaseurl + 'Registration/UserBFormList/' + UserID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    ReadBFormDetails(AppID) {
        return Vue.http.get(apibaseurl + 'Registration/UserBFormDetail/' + AppID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    ReadBFormSummary(FormID) {

        return Vue.http.get(apibaseurl + 'Registration/UserBFormSummary/' + FormID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    ReadPendingPaymentList(AgencyID) {
        return Vue.http.get(apibaseurl + 'AgencyRegistration/ReadPendingFeesByAgencyID/' + AgencyID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },

    //Save Nomination
    saveExperienceList(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserExperienceList', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove experince from Experience List
    deleteExperienceList(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserExperienceListRm', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Nominations
    ReadUserExperienceList(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserExperienceListByUserID/' + user,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getMeritbyApplicationID(applicationID) {
        return Vue.http.get(apibaseurl + 'Events/ReadMeritbyApplicationID/' + applicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    getEventMeritbyId(eventID, ListType, MeritType) {
        return Vue.http.get(apibaseurl + 'Events/ReadMeritList/' + eventID + '/' + ListType + '/' + MeritType,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    //Survey
    getQuestions(surveyType) {
        return Vue.http.get(apibaseurl + 'GuardSurvey/GetSurveyQuestions/' + surveyType,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    SaveSurvey(payload) {
        return Vue.http.post(apibaseurl + 'GuardSurvey/SaveSurvey', payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    SendOTP(form) {
        return Vue.http.post(apibaseurl + 'GuardSurvey/SendOTP', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    VerifyOTP(form) {
        return Vue.http.post(apibaseurl + 'GuardSurvey/VerifiyOTP', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    GetNotifications(userid) {
        return Vue.http.get(apibaseurl + 'Login/GetNotifications/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    NotificationsMarkRead(userid) {
        return Vue.http.get(apibaseurl + 'Login/NotificationMarkReadByUser/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveConfirmPassword(user) {
        return Vue.http.post(apibaseurl + 'Login/saveConfirmPassword', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    AddExemptionEmployer(exemptionApplication) {
        return Vue.http.post(apibaseurl + 'Exemption/AddEmployer', exemptionApplication, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    GetExtempionEmployerListStg(userid) {
        return Vue.http.get(apibaseurl + 'Exemption/GetStgEmployerList_ByAppID/00000000-0000-0000-0000-000000000000/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            } 
        });
    },

    submitExemptApplication(applicationId, userid) {
        return Vue.http.post(apibaseurl + 'Exemption/SaveExemptionApplication/' + applicationId + '/' + userid, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    GetPendingExemptions(userid) {
        return Vue.http.get(apibaseurl + 'Exemption/GetApplicationList_ByAgencyId/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadExemptionApplication(applicationID) {
        return Vue.http.get(apibaseurl + 'ExemptApplication/ReadAgencyDetails/' + applicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadExemptionApplicationGuards(applicationID) {
        return Vue.http.get(apibaseurl + 'ExemptApplication/ReadApplicationGuardMapping/' + applicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadExemptionApplicationEmployer(applicationID) {
        return Vue.http.get(apibaseurl + 'ExemptApplication/ReadApplicationEmployerMapping/' + applicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    RemoveStageExemptionGuard(guardID) {
        return Vue.http.get(apibaseurl + 'Exemption/RemoveStageGuard/' + guardID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    async RemoveStageExemptionEmployer(employerID) {
        return await Vue.http.get(apibaseurl + 'Exemption/RemoveStageEmployer/' + employerID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    RemoveStageExemptionApplication(applicationID) {
        return Vue.http.get(apibaseurl + 'Exemption/RemoveStageApplication/' + applicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getSchedule() {
        return Vue.http.get(apibaseurl + 'DB/GetSchedule',{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadStgGuardsByEmployerID(employerID) {
        return Vue.http.get(apibaseurl + 'Exemption/ReadStgGuardsByEmployerID/' + employerID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getExemptionApplicationEmployerMapping(appid, userid) {
        return Vue.http.get(apibaseurl + 'Exemption/GetStgEmployerList_ByAppID/' + appid + '/' + userid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getExemptionApplicationGuardMapping(appid, userid) {
        return Vue.http.get(apibaseurl + 'ExemptApplication/ReadApplicationGuardMapping/' + appid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getStgApplicationGuardMapping(appid, userid) {
        return Vue.http.get(apibaseurl + 'Exemption/GetStgGuardList_ByAppID/' + appid,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    SavestgRegistrationDetails(regDetails) {
        return Vue.http.post(apibaseurl + 'Exemption/SaveGuard', regDetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },
    GetExemptionApplicationList_ByAgencyId(AgencyID) {
        return Vue.http.get(apibaseurl + 'Exemption/GetExemptionApplicationList_ByAgencyId/' + AgencyID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },
    // ReadCalculate_Exemption_PaymentFee(AgencyID,exemptionapplicationID) {
    //     return Vue.http.get(apibaseurl + 'Exemption/GetCalculate_Exemption_PaymentFee/' + AgencyID+'/'+exemptionapplicationID);
    // },
    // ReadCalculate_Exemption_PaymentFee(form) {
    //     return Vue.http.post(apibaseurl + 'Exemption/GetCalculate_Exemption_PaymentFee', form, {
    //         headers: {
    //             "Content-Type": "application/json",
    //         }
    //     });
    // },
       ReadCalculate_Exemption_PaymentFee(AgencyID,exemptionapplicationID) {
        return Vue.http.get(apibaseurl + 'Exemption/GetCalculate_Exemption_PaymentFee/' + AgencyID+'/'+exemptionapplicationID,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });
    },
    SaveAppRegistrationDetails(regDetails) {
        return Vue.http.post(apibaseurl + 'ExemptApplication/SaveGuard', regDetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },
    SaveApplicationRegistrationDetails(regDetails) {
        return Vue.http.post(apibaseurl + 'ExemptApplication/SaveAgencyRegistration', regDetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },
    SaveStgApplicationRegistrationDetails(regDetails) {
        return Vue.http.post(apibaseurl + 'ExemptApplication/SaveStgAgencyRegistration', regDetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },
    CheckGuardDuplicate(aadharno, guard_reg_no) {
        return Vue.http.get(apibaseurl + 'exemptApplication/GuardDuplicate/' + aadharno + '/' + guard_reg_no,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        });


    },
    GetGazette_by_agency_wise(data) {
        return Vue.http.post(apibaseurl + 'Exemption/GetGazette_by_agency_wise', data, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken

            }
        })
    },


}



// WEBPACK FOOTER //
// ./src/apis/index.js